import { toast } from 'react-toastify';
import { getAllShareLinks,getAllShareLinksFiles } from '../modules/data-rooms/core/_requests';
import { useIntl } from 'react-intl'
import { useMoveToFolderData } from '../modules/data-rooms/core/FileToFolderAuth';

const useShareLinks = (dataRoomId: any, contentId: any) => {
 const{setShareLinkApiLoading,setShareLinkApiData}=useMoveToFolderData()
 
  const { formatMessage } = useIntl()

  const getAllShareLinksByDataRoomId = async () => {
    try {
      setShareLinkApiLoading(true);
      if (dataRoomId) {
        const {
          data: { data, success, errors },
        } = await getAllShareLinks(+dataRoomId);
        if (success) {
          setShareLinkApiData(data);
        } else {
          errors.forEach((error: any) => {
            toast.error(formatMessage({ id: error }));
          });
        }
      } else {
        if (contentId) {
          const {
            data: { data, success, errors },
          } = await getAllShareLinksFiles(contentId);
          if (success) {
            setShareLinkApiData(data);
          } else {
            errors.forEach((error: any) => {
              toast.error(formatMessage({ id: error }));
            });
          }
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setShareLinkApiLoading(false);
    }
  };


  return {  getAllShareLinksByDataRoomId };
};

export default useShareLinks;


